import { render, staticRenderFns } from "./CommentBlock.vue?vue&type=template&id=7e25ee1c&scoped=true&"
import script from "./CommentBlock.vue?vue&type=script&lang=js&"
export * from "./CommentBlock.vue?vue&type=script&lang=js&"
import style0 from "./CommentBlock.vue?vue&type=style&index=0&id=7e25ee1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e25ee1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
